import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { CommonButton } from 'gemlux-common-components';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { subordinateActions } from '../../../../redux/subordinate/subordinateSlice';
import { RootState } from '../../../../redux/store';
import CustomModal from '../../../V1/CustomModal/CustomModal';
import DeleteSvg from '../../../../assets/img/delete-red.svg';
import { theme } from '../../../../theme/theme';
import AvatarEdit from '../../../AvatarEdit/AvatarEdit';

function DeleteSubordinateModal(): ReactElement {
  const dispatch = useAppDispatch();
  const subordinateToDelete = useAppSelector((state: RootState) => state.subordinate.subordinateToDelete);
  const componentStatus = useAppSelector((state: RootState) => state.subordinate.componentStatus);

  const isLoading = componentStatus.deleteSubordinateLoading ?? false;
  const isModelOpen = componentStatus.isDeleteSubordinateModalOpen ?? false;

  const handleCloseModal = () => {
    if (!isLoading) dispatch(subordinateActions.closeDeleteSubordinateModal());
  };

  const handleDeleteSubordinate = () => {
    if (subordinateToDelete && subordinateToDelete.userId) {
      dispatch(subordinateActions.deleteSubordinateAsync({ userId: subordinateToDelete.userId }));
    }
  };

  return (
    <CustomModal
      modal
      open={isModelOpen}
      handleClose={handleCloseModal}
      Icon={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '64px',
            height: '64px',
            borderRadius: '32px',
            background: 'var(--Danger-danger-200, #FFDEE0)',
          }}
        >
          <Box
            component="img"
            src={DeleteSvg}
            alt="Delete Icon"
            sx={{
              width: '40px',
              height: '40px',
            }}
          />
        </Box>
      }
      title="Following Subordinate will be deleted!"
      subTitle="Are you sure you want to delete this Subordinate?"
    >
      <Box display="flex" flexDirection="column" gap="8px" justifyContent="end" alignItems="center" mt={1}>
        <Box display="flex" alignItems="center" gap={2}>
          <AvatarEdit
            editable={false}
            name={subordinateToDelete?.firstName}
            name2={subordinateToDelete?.familyName}
            font={theme.typography.footnoteBold}
            size="28px"
          />
          <Typography variant="textBase500">
            {subordinateToDelete?.firstName} {subordinateToDelete?.familyName}
          </Typography>
        </Box>
        <CommonButton
          variant="contained"
          data-testid="recall-button"
          sx={{ width: '100%', backgroundColor: theme.palette.shades.errorBrightMain, marginTop: '10px' }}
          onClick={handleDeleteSubordinate}
          loading={isLoading}
        >
          Yes, delete
        </CommonButton>
        <CommonButton
          variant="outlined"
          data-testid="cancel-button"
          sx={{
            width: '100%',
            color: theme.palette.common.black,
            border: `1px solid ${theme.palette.shades.grayBorder}`,
          }}
          onClick={handleCloseModal}
        >
          Cancel
        </CommonButton>
      </Box>
    </CustomModal>
  );
}

export default DeleteSubordinateModal;
